import { FC, useMemo } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@ibsys/kit';
import { useTranslation } from 'react-i18next';
import type { BillingDailyUsage } from '@/entities/billing';

type Props = {
  items: BillingDailyUsage[];
};

/** Извлекает номер дня месяца из строки `YYYY-MM-DD`. */
const getDayOfMonth = (date: string): string => {
  const day = Number(date.slice(-2));
  return String(day);
};

/**
 * Вертикальная столбчатая диаграмма расхода минут по дням месяца.
 * Ось X — день месяца, ось Y — потреблено минут.
 */
export const DailyUsageChart: FC<Props> = ({ items }) => {
  const { t } = useTranslation('billing');

  const maxValue = useMemo(() => items.reduce((acc, item) => Math.max(acc, item.minutes), 0), [items]);

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('dailyUsageTitle')}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-stretch gap-2 h-64">
          {items.map((item) => {
            const heightPct = maxValue > 0 ? (item.minutes / maxValue) * 100 : 0;
            return (
              <div key={item.date} className="flex flex-1 flex-col items-center gap-2 min-w-0">
                <span className="text-xs text-muted-foreground">{item.minutes}</span>
                <div className="w-full flex-1 flex items-end">
                  <div
                    className="w-full bg-primary rounded-t transition-all"
                    style={{ height: `${Math.max(2, heightPct)}%` }}
                    aria-label={t('barAriaLabel', { date: item.date, minutes: item.minutes })}
                  />
                </div>
                <span className="text-xs text-muted-foreground">{getDayOfMonth(item.date)}</span>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};
